import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

/**
 * The gradient "AI" trigger, shared by every automatic-compilation action: the
 * per-question button, "compila tutte le risposte", and the PEF description
 * generator.
 *
 * It fixes the parts that make it recognisable — sparkles icon, secondary,
 * small, ghost until hover — and exposes only what the three call sites
 * actually differ on. That is deliberately not the whole `p-button` API: the
 * point is that an AI action cannot be styled into something else by accident.
 *
 * Note the *filled* variant in `result/result.css` is a different look on a
 * different action ("Richiedi valutazione") and is not this component.
 */
@Component({
  selector: 'lib-ai-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, TooltipModule],
  template: `
    <p-button
      [label]="label()"
      [icon]="icon()"
      severity="secondary"
      size="small"
      [text]="true"
      [rounded]="rounded()"
      [loading]="loading()"
      [disabled]="disabled() || loading()"
      [pTooltip]="tooltip()"
      tooltipPosition="left"
      (onClick)="action.emit()"
    />
  `,
  styleUrl: './ai-button.css',
})
export class AiButtonComponent {
  /** Omit for an icon-only button. */
  readonly label = input<string>();
  readonly icon = input('pi pi-sparkles');
  readonly rounded = input(false);
  /** Worth setting whenever `label` is omitted. */
  readonly tooltip = input('');
  readonly loading = input(false);
  readonly disabled = input(false);

  readonly action = output<void>();
}
